import React from 'react';
import jsonLD from '@schemas/json-ld';
import createGeneral from '@schemas/create-general';
import PropTypes from 'prop-types';

const Schema = ({ breadcrumbs }) => {
  const breadcrumb = {
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map((item, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: item.schemaLabel || item.label,
      item: item.url,
    })),
  };

  return (
    <>
      {jsonLD({ info: breadcrumb })}
      {createGeneral('search')}
    </>
  );
};

Schema.propTypes = {
  breadcrumbs: PropTypes.array,
};

export default Schema;
